import "./ReferralPromocodeBenefitRow.css"

interface IReferralPromocodeBenefitRowProps {
    icon: string
    title: string
    subtitle: string
    isMobile: boolean
}

export default function ReferralPromocodeBenefitRow(props: IReferralPromocodeBenefitRowProps) {
    if (props.isMobile) {
        return <div className="Referral_promocode_benefit_row_mobile">
            <img src={props.icon} className="Referral_promocode_benefit_row_image_mobile" />
            <span className="Referral_promocode_benefit_row_text_title_mobile">{props.title}</span>
            <span className="Referral_promocode_benefit_row_text_subtitle_mobile">{props.subtitle}</span>
        </div>
    } else {
        return <div className="Referral_promocode_benefit_row">
            <img src={props.icon} className="Referral_promocode_benefit_row_image" />
            <div className="Referral_promocode_benefit_row_text_container">
                <span className="Referral_promocode_benefit_row_text_title">{props.title}</span>
                <span className="Referral_promocode_benefit_row_text_subtitle">{props.subtitle}</span>
            </div>
        </div>
    }
}